import React, {Component} from 'react';
import {Col} from 'react-flexbox-grid';
import './Card.css';
import List from "./List";
import DoubleDate from "./DoubleDate";
import _ from 'underscore';
import Photo from "./Photo";

class Card extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        if (!this.props.entry.fields['Activité']
            || this.props.entry.fields['Activité'].length === 0) {
            return null;
        }

        const children = [];
        const before = [];

        _.each(this.props.format, (format, index) => {
            if (format.mode === "list") {
                children.push((
                    <List format={format} key={index} entry={this.props.entry}/>
                ));
            } else if (format.mode === "doubleDate") {
                children.push((
                    <DoubleDate format={format} key={index} entry={this.props.entry}/>
                ));
            } else if (format.mode === "photo") {
                before.push((
                    <Photo format={format} key={index} entry={this.props.entry}/>
                ));
            }
        });

        return (
            <Col sm={12} md={6} style={{width: '100%'}}>
                <div className="Maintenant-Card">
                    {before}
                    <h2>{this.props.entry.fields['Activité'][0].fields['Titre: Nom de l\'intervention']}</h2>
                    {children}

                </div>
            </Col>
        );
    }
}

export default Card;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCards/Card.js